export default __webpack_public_path__ + "static/media/blog-3-300x250.08251626.png";